var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { makeObservable, observable, action, isObservable, untracked, toJS } from "mobx";
import { clone, get, set } from "lodash";
import { each, isArr, isFn, isPlainObj } from "@al/aku-lc-helpers";
import { buildPath } from "@al/aku-lc-path";
import { LifeCycleTypes } from "../types";
import { container, PUB_SUB } from "../container";
import { Query } from "./query";
/**
 * TODO: 在 form 提交，值变化等各个阶段 publish 通知
 */
var Form = /** @class */ (function () {
    function Form(props) {
        var _this = this;
        Object.defineProperty(this, "_path", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_submitting", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_validating", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_value", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_initialValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_touched", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "disposers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "pubSub", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "initialize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (props) {
                _this._submitting = false;
                _this._validating = false;
                _this._initialValue = isObservable(props.initialValue)
                    ? props.initialValue || {}
                    : clone(props.initialValue) || {};
                _this._value = isObservable(props.value)
                    ? props.value || {}
                    : clone(props.value) || _this.initialValue;
            }
        });
        Object.defineProperty(this, "makeObservable", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                makeObservable(_this, {
                    _submitting: observable,
                    _validating: observable,
                    _initialValue: observable,
                    _value: observable,
                    setSubmitting: action,
                    setValidating: action,
                });
            }
        });
        Object.defineProperty(this, "trimFormPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (p) {
                return (p === null || p === void 0 ? void 0 : p.replace(_this._path, "").replace("/", "")) || "";
            }
        });
        /**
         * @param k string
         * @returns string
         * TODO: 对 key 的处理暂时比较简单，支持 "a.b" 形式转换为 { a: { b: value } }
         * |a, b| 转换为 { a: value[0], b: value[1] }
         */
        Object.defineProperty(this, "transformKey", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (k) {
                var key = _this.trimFormPath(k).replace("/", ".");
                if (key.startsWith(".")) {
                    key = key.slice(1);
                }
                return key;
            }
        });
        Object.defineProperty(this, "handleDestructorExpr", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (key, value, result) {
                var matchedKeys = key.match(/((?:\w+)+)/g);
                if (matchedKeys) {
                    for (var i = 0; i < (matchedKeys === null || matchedKeys === void 0 ? void 0 : matchedKeys.length); i++) {
                        result[matchedKeys[i]] = value[i];
                    }
                }
            }
        });
        Object.defineProperty(this, "formatValues", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (values) {
                var result = {};
                var fields = _this.queryFields();
                each(values || {}, function (value, k) {
                    var pathKey = _this.transformKey(k);
                    var field = fields.find(function (field) { return field.path === buildPath(k, _this._path); });
                    var key = (field === null || field === void 0 ? void 0 : field.fieldName) || pathKey;
                    if (key) {
                        if (key.startsWith("|") && key.endsWith("|")) {
                            _this.handleDestructorExpr(key, value, result);
                        }
                        else if (isPlainObj(value) || isArr(value)) {
                            set(result, key, _this.formatValues(value));
                        }
                        else {
                            set(result, key, value);
                        }
                    }
                });
                return result;
            }
        });
        Object.defineProperty(this, "subscribe", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                _this.pubSub.subscribe(LifeCycleTypes.OnFormSubmitSuccess, _this.onSubmitFinish);
                _this.pubSub.subscribe(LifeCycleTypes.OnFormSubmitFailed, _this.onSubmitFinish);
            }
        });
        Object.defineProperty(this, "onSubmitFinish", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (data) {
                if ((data === null || data === void 0 ? void 0 : data.formPath) === _this.path) {
                    _this.setSubmitting(false);
                }
            }
        });
        Object.defineProperty(this, "setSubmitting", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (submitting) {
                _this._submitting = submitting;
            }
        });
        Object.defineProperty(this, "setValidating", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (validating) {
                _this._validating = validating;
            }
        });
        Object.defineProperty(this, "setInitialValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (val) {
                _this._initialValue = val;
                _this._value = val;
            }
        });
        Object.defineProperty(this, "setValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (val) {
                _this._value = val;
            }
        });
        Object.defineProperty(this, "setInitialValueIn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (path, val) {
                untracked(function () {
                    var values = toJS(_this.initialValue);
                    set(values, _this.trimFormPath(path), val);
                    _this._initialValue = values;
                });
            }
        });
        Object.defineProperty(this, "setTouched", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (v) {
                _this._touched = v;
            }
        });
        Object.defineProperty(this, "getInitialValueIn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (path) {
                return get(_this.initialValue, _this.trimFormPath(path));
            }
        });
        Object.defineProperty(this, "setValueIn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (path, val) {
                untracked(function () {
                    var values = toJS(_this.value);
                    set(values, _this.trimFormPath(path), val);
                    _this._value = values;
                });
            }
        });
        Object.defineProperty(this, "getValueIn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (path) {
                return get(_this.value, _this.trimFormPath(path));
            }
        });
        Object.defineProperty(this, "queryFields", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                return new Query(_this.path).getChildren();
            }
        });
        Object.defineProperty(this, "validate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () { return __awaiter(_this, void 0, void 0, function () {
                var tasks;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.setValidating(true);
                            tasks = [];
                            this.queryFields().forEach(function (field) {
                                tasks.push(field.validate());
                            });
                            return [4 /*yield*/, Promise.all(tasks)];
                        case 1:
                            _a.sent();
                            this.setValidating(false);
                            if (this.invalid) {
                                throw this.errors;
                            }
                            return [2 /*return*/];
                    }
                });
            }); }
        });
        Object.defineProperty(this, "submit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (onSubmit) { return __awaiter(_this, void 0, void 0, function () {
                var error_1, result, error_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.setSubmitting(true);
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, this.validate()];
                        case 2:
                            _a.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            error_1 = _a.sent();
                            return [3 /*break*/, 4];
                        case 4:
                            _a.trys.push([4, 8, , 9]);
                            if (this.invalid) {
                                throw this.errors;
                            }
                            if (!isFn(onSubmit)) return [3 /*break*/, 6];
                            return [4 /*yield*/, onSubmit(toJS(this.value))];
                        case 5:
                            result = _a.sent();
                            return [3 /*break*/, 7];
                        case 6:
                            result = toJS(this.value);
                            _a.label = 7;
                        case 7: return [3 /*break*/, 9];
                        case 8:
                            error_2 = _a.sent();
                            this.setSubmitting(false);
                            throw error_2;
                        case 9:
                            // 先在提交时才格式化 key
                            result = this.formatValues(result);
                            this.pubSub.publishSync(LifeCycleTypes.OnFormSubmit, result);
                            return [2 /*return*/, result];
                    }
                });
            }); }
        });
        Object.defineProperty(this, "onMount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                // TODO:
            }
        });
        Object.defineProperty(this, "onUnmount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                _this.queryFields().forEach(function (field) {
                    field.dispose();
                });
                _this.dispose();
            }
        });
        Object.defineProperty(this, "reset", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function (options) { return __awaiter(_this, void 0, void 0, function () {
                var tasks;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            tasks = [];
                            this.queryFields().forEach(function (field) {
                                tasks.push(field.reset(options));
                            });
                            return [4 /*yield*/, Promise.all(tasks)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); }
        });
        Object.defineProperty(this, "dispose", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                _this.disposers.forEach(function (disposer) {
                    disposer();
                });
            }
        });
        this._path = props.path;
        this.pubSub = container.resolve(PUB_SUB);
        this.initialize(props);
        this.makeObservable();
        this.subscribe();
    }
    Object.defineProperty(Form.prototype, "path", {
        get: function () {
            return this._path;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Form.prototype, "submitting", {
        get: function () {
            return this._submitting;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Form.prototype, "validating", {
        get: function () {
            return this._validating;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Form.prototype, "value", {
        get: function () {
            return this._value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Form.prototype, "initialValue", {
        get: function () {
            return this._initialValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Form.prototype, "invalid", {
        get: function () {
            var flag = false;
            var keys = Object.keys(this.errors);
            for (var i = 0; i < keys.length; i++) {
                var key = keys[i];
                var item = this.errors[key];
                if (item && item.length) {
                    flag = true;
                    break;
                }
            }
            return flag;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Form.prototype, "errors", {
        get: function () {
            var result = {};
            this.queryFields().forEach(function (field) {
                result[field.path] = field.errors;
            });
            return result;
        },
        enumerable: false,
        configurable: true
    });
    return Form;
}());
export { Form };
